import { InputNumber, message, Modal, Switch } from 'antd'
import { useEffect, useState } from 'react'
import apiClient from '../../Utils/apiClient'

export default function DocumentRetentionModal({ documentId, open, onClose, onSaved }) {
  const [retentionDays, setRetentionDays] = useState(0)
  const [legalHold, setLegalHold] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!open || !documentId) {
      return
    }

    apiClient.get(`filestructure/get-file/${documentId}`).then(({ data }) => {
      const doc = data?.result
      if (doc) {
        setRetentionDays(doc.retentionDays || 0)
        setLegalHold(Boolean(doc.legalHold))
      }
    })
  }, [open, documentId])

  const onSave = () => {
    setLoading(true)
    apiClient
      .put(`filestructure/${documentId}/retention`, { retentionDays, legalHold })
      .then(() => {
        message.success('Retention settings saved')
        onSaved?.()
        onClose()
      })
      .finally(() => setLoading(false))
  }

  return (
    <Modal
      title="Retention & legal hold"
      open={open}
      onCancel={onClose}
      onOk={onSave}
      confirmLoading={loading}
      okText="Save">
      <p>Auto-delete after N days from creation (0 = no auto-delete). Legal hold prevents deletion.</p>
      <label>Retention days</label>
      <InputNumber min={0} value={retentionDays} onChange={setRetentionDays} style={{ width: '100%', marginBottom: 16 }} />
      <div>
        <Switch checked={legalHold} onChange={setLegalHold} /> Legal hold
      </div>
    </Modal>
  )
}
